import React from 'react';
import TenantSelectionForm from '../../components/tenant/TenantSelectionForm/TenantSelectionForm';
import './TenantSelectionPage.css';
import logo from '../../assets/logo.png';

const TenantSelectionPage = () => {
    return (
        <div className="tenant-selection-page">
            <div
                className="background-logo"
                style={{
                    backgroundImage: `url(${logo})`,
                    backgroundSize: 'contain',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    opacity: 0.30,
                    position: 'absolute',
                    inset: 0,
                    zIndex: 0,
                }}
            />
            <div className="tenant-selection-container">
                <div className="tenant-selection-content">
                    <TenantSelectionForm />
                </div>
            </div>
        </div>
    );
};

export default TenantSelectionPage;